var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.sections.length
    ? _c(
        "div",
        { staticClass: "review-card-comments d-flex flex-column ga-4" },
        [
          _vm.showWatermark
            ? _c(_setup.ReviewCardLogo, { attrs: { "is-watermark": true } })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sections, function (section) {
            return _c(
              "div",
              {
                key: section.field,
                staticClass:
                  "review-card-comments__item d-flex flex-column ga-2",
                class: {
                  "review-card-comments__item--limited": _vm.limitWidth,
                },
              },
              [
                _c("div", { staticClass: "text-subtitle-2 text--text" }, [
                  _vm._v("\n      " + _vm._s(section.title) + "\n    "),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "review-card-comments__text text-body-1 text--text",
                  class: {
                    "review-card-comments__text--truncated": _vm.truncated,
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      section.html /* eslint-disable-line vue/no-v-html */
                    ),
                  },
                }),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }